<template>
  <div
    v-if="activeLabels.length || $slots.before"
    ref="labelContainer"
    class="relative"
  >
    <div class="flex items-end flex-shrink min-w-0 gap-y-1">
      <slot name="before" />
      <woot-label
        v-for="label in visibleLabels"
        :key="label.id"
        :title="label.title"
        :description="label.description"
        :color="label.color"
        class="max-w-[calc(100%-0.5rem)]"
        small
      />
    </div>
    <div v-if="hiddenLabels.length" class="relative">
      <span
        v-if="variant === 'arrow'"
        ref="triggerBadge"
        class="material-symbols-outlined cursor-pointer text-base/4 text-gray-500 rounded-[4px] hover:bg-gray-200"
        @mouseover="showTooltip"
        @mouseleave="showHiddenLabels = false"
      >
        stat_minus_1
      </span>
      <div v-else class="bg-white rounded-lg flex items-center">
        <span
          ref="triggerBadge"
          class="semantic-tag small tag-mute-0 bg-[#4755690A] cursor-pointer"
          @mouseover="showTooltip"
          @mouseleave="showHiddenLabels = false"
        >
          +{{ hiddenLabels.length }}
        </span>
      </div>
      <div
        class="tooltip-popup"
        :class="showHiddenLabels ? 'flex' : 'hidden'"
        :style="tooltipStyle"
      >
        <div class="tooltip-arrow" />
        <div
          class="bg-white rounded-[8px] px-2 py-1 flex flex-col gap-1 w-[120px] items-start"
        >
          <woot-label
            v-for="label in hiddenLabels"
            :key="label.id"
            :title="label.title"
            :description="label.description"
            :color="label.color"
            class="max-w-[calc(100%-0.5rem)] relative z-[1]"
            small
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import conversationLabelMixin from 'dashboard/mixins/conversation/labelMixin';
export default {
  mixins: [conversationLabelMixin],
  props: {
    conversationId: {
      type: Number,
      required: true,
    },
    conversationLabels: {
      type: Array[String],
      required: false,
      default: '',
    },
    variant: {
      type: String,
      default: 'arrow',
    },
  },
  data() {
    return {
      showHiddenLabels: false,
      tooltipStyle: {},
    };
  },
  computed: {
    visibleLabels() {
      return this.activeLabels.length > 3
        ? this.activeLabels.slice(0, 3)
        : this.activeLabels;
    },
    hiddenLabels() {
      return this.activeLabels.length > 3 ? this.activeLabels.slice(3) : [];
    },
  },
  methods: {
    async checkFetchLabels() {
      if (!this.savedLabels.length) {
        await this.$store.dispatch(
          'conversationLabels/get',
          this.conversationId
        );
      }
    },
    showTooltip() {
      const rect = this.$refs.triggerBadge.getBoundingClientRect();
      this.tooltipStyle = {
        position: 'fixed',
        left: `${rect.left + rect.width / 2}px`,
        top: `${rect.top + rect.height + 8}px`,
        transform: 'translateX(-50%)',
      };
      this.showHiddenLabels = true;
    },
    onShowLabels(e) {
      e.stopPropagation();
      this.showHiddenLabels = !this.showHiddenLabels;
    },
  },
};
</script>

<style lang="scss" scoped>
.show-more--button {
  @apply h-5;
  &.secondary:focus {
    @apply text-slate-700 dark:text-slate-200 border-slate-300 dark:border-slate-700;
  }
}

.labels-wrap {
  .secondary {
    @apply border border-solid border-slate-100 dark:border-slate-700;
  }
}

.tooltip-popup {
  @apply flex-col items-center;
  z-index: 9999;
  filter: drop-shadow(0px 1px 2px rgba(17, 24, 39, 0.1))
    drop-shadow(0px 1px 1px rgba(17, 24, 39, 0.06));
}

.tooltip-arrow {
  width: 12px;
  height: 12px;
  background: white;
  border-radius: 2px;
  transform: rotate(45deg);
  margin-bottom: -6px;
  flex-shrink: 0;
  position: relative;
  z-index: 0;
}
</style>
